<script>
export default {
    data: function () {
        return {
            mapId: 'Ymap',
            mapSettings: {
                clinicsPlacemark: null,
                clinicsMap: null
            },
        };
    },
    mounted() {
        this.$bus.listen('sidebar-toggle', () => {
            setTimeout(() => {
                this.fillContainer();
            }, 250);
        })
    },

    methods: {
        initMap: function (disable) {
            let coords = [59.9306, 30.3677];

            let clinicsMap = new ymaps.Map(this.mapId, {
                center: coords,
                zoom: 17,
                controls: []
            });

            //Определяем элемент управления поиск по карте
            let SearchControl = new ymaps.control.SearchControl({
                noPlacemark: true,
            });

            //Добавляем элементы управления на карту
            clinicsMap.controls.add('zoomControl');

            //Определяем метку и добавляем ее на карту
            let clinicsPlacemark = new ymaps.Placemark(coords, {}, {
                preset: "islands#redIcon",
                iconColor : disable ? "#b3b3b3" : "#ff0000",
                draggable: !disable
            });
            clinicsMap.geoObjects.add(clinicsPlacemark);

            //Отслеживаем событие перемещения метки
            clinicsPlacemark.events.add("dragend", event => {
                this.coordsToModel(event.get('target').geometry.getCoordinates());
            }, clinicsPlacemark);

            //Отслеживаем событие выбора результата поиска
            SearchControl.events.add("resultselect", event => {
                this.coordsToModel();
            });

            //Ослеживаем событие изменения области просмотра карты - масштаб и центр карты
            clinicsMap.events.add('boundschange', event => {
                this.coordsToModel();
            });

            clinicsMap.container.fitToViewport();

            this.mapSettings.clinicsPlacemark = clinicsPlacemark;
            this.mapSettings.clinicsMap = clinicsMap;
        },
        updateMap: function (markLat, markLong, mapZoom) {
            if (this.mapSettings.clinicsPlacemark) {
                this.mapSettings.clinicsPlacemark.geometry.setCoordinates([markLat, markLong]);
                this.mapSettings.clinicsMap.setCenter([markLat, markLong]);

                this.mapSettings.clinicsMap.setZoom(mapZoom);
            }
        },
        fillContainer() {
            this.mapSettings.clinicsMap.container.fitToViewport();
        }
    }
}
</script>

<style lang="scss">

</style>
